import { apiRegistry } from '../../../common/infra/apiRegistry'
import { favoritesMem } from '../mem/favoritesMem'

apiRegistry.registerGetApi('isFavorite', async (req) => {
  return { isFavorite: req.wordId in favoritesMem }
})
